/**
 * Stream Row Tokens — presentational core of the agent event stream
 * (kit/stream). `bg`/`divider`/`bubble` are terminal-tuned overrides with no
 * direct semantic equivalent (near-black canvas + low-opacity divider/bubble,
 * distinct from the general surface/border scale used elsewhere); everything
 * else composes straight from semantic accent/text.
 */
import { bg, text, accent } from "../semantic";
import { mix } from "../mix";

export const streamRow = {
  bg: "var(--cg-stream-bg)",
  surface: bg.base,
  divider: "var(--cg-stream-muted)",
  bubble: "var(--cg-stream-bubble)",
  pill: mix(accent.primary, 12),
  text: text.primary,
  dim: text.muted,
  // Мета-строки ленты (тайминги, «N lines · tap to expand»). Раньше их красил
  // `divider` — канвас-токен разделителя #262626: контраст 1.29 на тёмной и
  // 1.68 на светлой, текст фактически невидим (находка reels, 16.08).
  // `dim` тоже мимо (4.01 и 3.26 — ниже нормы 4.5), поэтому tertiary: 8.79/5.99.
  meta: text.tertiary,
  // Row/tool status glyphs (✓ / ✕ / ⋯).
  ok: accent.success,
  fail: accent.danger,
  pending: accent.cyan,
  // Tool-type legend for ToolRow/BashRow labels + FileChip pills.
  tool: {
    Bash: accent.warning, Read: accent.info,
    Edit: accent.success, Write: accent.success,
    Glob: accent.violet, Grep: accent.violet,
    Agent: accent.amber, Explore: accent.amber,
  },
} as const;
